import { toast } from '../components/ui/use-toast';

interface ToastOptions {
  title: string;
  description?: string;
  variant?: 'default' | 'destructive';
}

export function useToast() {
  const showToast = ({ title, description, variant = 'default' }: ToastOptions) => {
    toast({
      title,
      description,
      variant,
    });
  };

  return { toast: showToast };
} 